const AUTH_REDIRECT_NOTICE_KEY = 'auth_redirect_notice';

const DEFAULT_MESSAGES = {
  missing: 'Please log in to continue.',
  expired: 'Your session has expired. Please log in again.',
  admin: 'Please log in with an admin account to continue.',
};

export const clearStoredAuth = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
};

export const getLoginPath = ({ requiredRole, pathname = '' } = {}) => {
  if (requiredRole === 'admin' || pathname.startsWith('/admin')) {
    return '/admin/login';
  }

  return '/login';
};

export const setAuthRedirectNotice = ({ loginPath, message }) => {
  sessionStorage.setItem(
    AUTH_REDIRECT_NOTICE_KEY,
    JSON.stringify({
      loginPath,
      message,
      createdAt: Date.now(),
    })
  );
};

export const consumeAuthRedirectNotice = (loginPath) => {
  const rawNotice = sessionStorage.getItem(AUTH_REDIRECT_NOTICE_KEY);

  if (!rawNotice) {
    return null;
  }

  try {
    const notice = JSON.parse(rawNotice);

    if (notice.loginPath !== loginPath) {
      return null;
    }

    sessionStorage.removeItem(AUTH_REDIRECT_NOTICE_KEY);
    return notice.message;
  } catch (error) {
    sessionStorage.removeItem(AUTH_REDIRECT_NOTICE_KEY);
    return null;
  }
};

export const notifyAndRedirectToLogin = ({
  requiredRole,
  pathname,
  message,
  clearAuth = true,
} = {}) => {
  const loginPath = getLoginPath({ requiredRole, pathname });

  if (clearAuth) {
    clearStoredAuth();
  }

  setAuthRedirectNotice({
    loginPath,
    message:
      message ||
      (requiredRole === 'admin' ? DEFAULT_MESSAGES.admin : DEFAULT_MESSAGES.expired),
  });

  window.location.replace(loginPath);
};

export const AUTH_REDIRECT_MESSAGES = DEFAULT_MESSAGES;
